import React, {Component} from 'react';
import {Button, Col, Container, FormGroup, Input, Label, Row} from "reactstrap";
import {connect} from "react-redux";
import * as actions from '../../store/actions/index';
import { Redirect, withRouter } from "react-router-dom";

class Auth extends Component {

    state = {
        login: '',
        password: '',
    };

    componentDidMount() {
        if (this.props.authRedirectPath !== '/') {
            this.props.onSetAuthRedirectPath();
        }
    }

    onEmailUpdate = (event) => {
        this.setState({'login': event.target.value})
    };

    onPasswordUpdate = (event) => {
        this.setState({'password': event.target.value})
    };

    submitHandler = (event) => {
        event.preventDefault();
        this.props.onAuth(this.state.login, this.state.password, false);
    };

    render = () => {

        if (!this.props.isAuthDone) {
            return (
                <div>Authenticating</div>
            )
        }
        let authRedirect = null;
        if (this.props.isAuthenticated && (this.props.location.pathname==='/' || this.props.location.pathname==='/login')) {
            authRedirect = <Redirect to="/dashboard" />
        }
        return (
            <div>
                {authRedirect}
                <Container>
                    <Row>
                        <Col xs="6" sm="4"></Col>
                        <Col xs="6" sm="4">
                            <form onSubmit={this.submitHandler}>
                                <FormGroup>
                                    <Label for="exampleEmail">Użytkownik</Label>
                                    <Input type="text" name="login" id="login" placeholder="login"
                                           value={this.state.login}
                                           onChange={this.onEmailUpdate}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="examplePassword">Hasło</Label>
                                    <Input
                                        type="password"
                                        name="password"
                                        id="password"
                                        value={this.state.password}
                                        onChange={this.onPasswordUpdate}
                                    />
                                </FormGroup>
                                <Button color="success">Zaloguj się</Button>
                            </form>
                        </Col>
                        <Col sm="4"></Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthDone: state.auth.isAuthDone,
        isAuthenticated: state.auth.token !== null,
        authRedirectPath: state.auth.authRedirectPath
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (email, password, isSignup) => dispatch(actions.auth(email, password, isSignup)),
        onSetAuthRedirectPath: () => dispatch(actions.setAuthRedirectPath('/'))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Auth));




// WEBPACK FOOTER //
// ./src/containers/Login/Login.js